import { IMSection } from '../../types'
import { createNoteNode } from '../createNodeWrappers'
import { createNodeList } from '../../../nodeCreationHelpers'
import { parseAssessment } from '../assessment'
import { ancillaryItemsToString } from '../ancillary_content'
import { wrapP } from '../../../html_utility'

export function checkpointNote({ assessments: [assessment] }: IMSection) {
  if (!assessment?.teacher_instructions) return []
  if (assessment?.assessment_problems?.length) return []
  const ancillaryContent = Object.entries(assessment.ancillary_content ?? {})
    .map(([key, value]) => {
      return ancillaryItemsToString(key, value)
    })
    .join()
  return [
    createNoteNode({
      title: assessment.title,
      value: wrapP(assessment.teacher_instructions) + ancillaryContent,
      studentFacing: false,
    }),
  ]
}

export function checkpointAssessment({
  assessments: [assessment, ...rest],
}: IMSection) {
  if (!assessment) return []
  if (rest.length || assessment.category !== 'checkpoint') {
    throw new Error('Bad Assumption: section checkpoint')
  }
  if (!assessment.assessment_problems?.length) return []
  return [
    createNodeList({ title: 'Checkpoint' }, [
      parseAssessment(assessment, {
        assignment: 'quiz',
      }),
    ]),
  ]
}
